export default __webpack_public_path__ + "media/eduJessieErickson.7dea9c1d.jpg";